import { defineMessages } from 'react-intl';

export const highlightCondition = defineMessages({
  'dt:highlight_condition:less': {
    id: 'highlight_condition.less.title',
    defaultMessage: 'Less than',
    value: 'less',
  },
  'dt:highlight_condition:greater': {
    id: 'highlight_condition.greater.title',
    defaultMessage: 'Greater than',
    value: 'greater',
  },
  'dt:highlight_condition:less_equal': {
    id: 'highlight_condition.less_equal.title',
    defaultMessage: 'Less than equal',
    value: 'less_equal',
  },
  'dt:highlight_condition:greater_equal': {
    id: 'highlight_condition.greater_equal.title',
    defaultMessage: 'Greater than equal',
    value: 'greater_equal',
  },
  'dt:highlight_condition:equal': {
    id: 'highlight_condition.equal.title',
    defaultMessage: 'Equal',
    value: 'equal',
  },
  'dt:highlight_condition:contains': {
    id: 'highlight_condition.contains.title',
    defaultMessage: 'Text contains',
    value: 'contains',
  },
  'dt:highlight_condition:notequal': {
    id: 'highlight_condition.not_equal.title',
    defaultMessage: 'Not equal',
    value: 'not_equal',
  },
  'dt:highlight_condition:not_empty': {
    id: 'highlight_condition.not_empty.title',
    defaultMessage: 'Not empty',
    value: 'not_empty',
  },
  'dt:highlight_condition:empty': {
    id: 'highlight_condition.empty.title',
    defaultMessage: 'Empty',
    value: 'empty',
  },
});

export const highlightColor = defineMessages({
 'dt:highlight_color:#9b0005:#ffc7ce': {
    id: 'highlight_color.light_red_fill_with_dark_red_text.title',
    defaultMessage: 'Light red fill with dark red text',
    value: '#9b0005:#ffc7ce',
  },
 'dt:highlight_color:#9c5700:#ffeb9c': {
    id: 'highlight_color.yellow_fill_with_dark_yellow_text.title',
    defaultMessage: 'Yellow fill with dark yellow text',
    value: '#9c5700:#ffeb9c',
  },
 'dt:highlight_color:#026100:#c6efce': {
    id: 'highlight_color.green_fill_with_dark_green_text.title',
    defaultMessage: 'Green fill with dark green text',
    value: '#026100:#c6efce',
  }
});
